import { debounce as githubDebounce } from '@github/mini-throttle'

export const debounce = githubDebounce
